import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import {
  GroupInventoryReport,
  LocationInventoryReport,
} from 'src/app/core/models/reports/reports.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/environments/environment';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class InventoryReportsService {
  baseUrl = environment.apiUrl.concat('report-management/');
  constructor(
    private http: HttpClient,
    private commonUtils: CommonUtils,
    private errorHandler: ErrorhandleService,
  ) {}

  /**
   *Get a specific location inventory report based on the passed in location code
   *
   * @param {string} locationCode
   * @return {*}  {Observable<LocationInventoryReport>}
   * @memberof InventoryReportsService
   */
  getLocationInventoryReport(
    locationCode: string,
  ): Observable<LocationInventoryReport> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<LocationInventoryReport>(
        this.baseUrl.concat('location-inventory-report'),
        {
          params: { locationCode: locationCode },
        },
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<LocationInventoryReport>(
            error,
            error.status,
            'InventoryReports Service: Get location inventory report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   *Get a specific group inventory report based on the passed in location code
   *
   * @param {string} groupCode
   * @return {*}  {Observable<GroupInventoryReport>}
   * @memberof InventoryReportsService
   */
  getGroupInventoryReport(groupCode: string): Observable<GroupInventoryReport> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GroupInventoryReport>(
        this.baseUrl.concat('group-inventory-report'),
        {
          params: { groupCode },
        },
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GroupInventoryReport>(
            error,
            error.status,
            'InventoryReports Service: Get group inventory report',
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
